var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CSTSnackbarSingleton } from '../components/cst-snackbar/cst-snackbar';
import minDelay from './min-delay';
const ANIMATION_DELAY = 600;
export const getApiUrl = () => {
    const apiUrl = localStorage.getItem(`apiUrl`);
    return apiUrl;
};
export const getJsonboxKeyFromUrl = (url) => {
    return url.split('box_')[1] || '';
};
const findApiUrl = () => {
    const apiUrl = getApiUrl();
    if (!apiUrl) {
        CSTSnackbarSingleton.open('There was a problem finding the database. Please restart this application and try again');
        return null;
    }
    return apiUrl;
};
export const updateJsonboxKey = (key) => {
    localStorage.setItem('apiUrl', `https://jsonbox.io/box_${key}`);
};
const contentTypeApplicationJson = {
    'content-type': 'application/json',
};
export const GET = (path) => __awaiter(void 0, void 0, void 0, function* () {
    const apiUrl = findApiUrl();
    if (!apiUrl)
        return;
    const fullUrl = `${apiUrl}${path ? `/${path}` : ''}`;
    try {
        const response = yield minDelay(fetch(fullUrl, {
            method: 'GET',
            headers: Object.assign({}, contentTypeApplicationJson),
        }), ANIMATION_DELAY);
        const json = JSON.parse(yield response.text());
        return Promise.resolve(json);
    }
    catch (error) {
        CSTSnackbarSingleton.open(error);
    }
});
export const POST = (path, body) => __awaiter(void 0, void 0, void 0, function* () {
    const apiUrl = findApiUrl();
    if (!apiUrl)
        return;
    const fullUrl = `${apiUrl}${path ? `/${path}` : ''}`;
    try {
        const response = yield minDelay(fetch(fullUrl, {
            method: 'POST',
            headers: Object.assign({}, contentTypeApplicationJson),
            body: JSON.stringify(body),
        }), ANIMATION_DELAY);
        let json;
        try {
            json = yield response.json();
        }
        catch (error) {
            return Promise.reject(`The server sent back invalid JSON. ${error}`);
        }
        if (json.error != null) {
            return Promise.reject(json.error.message);
        }
        if (response.status === 201 || response.status === 200) {
            return Promise.resolve(json);
        }
        else {
            return Promise.reject('Request error, please try again later.');
        }
    }
    catch (error) {
        CSTSnackbarSingleton.open(error);
    }
});
export const PUT = (path, body) => __awaiter(void 0, void 0, void 0, function* () {
    const apiUrl = findApiUrl();
    if (!apiUrl)
        return;
    const fullUrl = `${apiUrl}${path ? `/${path}` : ''}`;
    try {
        const response = yield minDelay(fetch(fullUrl, {
            method: 'PUT',
            headers: Object.assign({}, contentTypeApplicationJson),
            body: JSON.stringify(body),
        }), ANIMATION_DELAY);
        let json;
        json = yield response.json();
        if (response.status === 201 || response.status === 200) {
            return Promise.resolve(json);
        }
    }
    catch (error) {
        CSTSnackbarSingleton.open(error);
    }
});
export const DELETE = (path, id) => __awaiter(void 0, void 0, void 0, function* () {
    const apiUrl = findApiUrl();
    if (!apiUrl || !path || !id)
        return;
    const fullUrl = `${apiUrl}${path ? `/${path}` : ''}${id ? `/${id}` : ''}`;
    try {
        const response = yield minDelay(fetch(fullUrl, {
            method: 'DELETE',
            headers: Object.assign({}, contentTypeApplicationJson),
        }), ANIMATION_DELAY);
        const json = JSON.parse(yield response.text());
        return Promise.resolve(json);
    }
    catch (error) {
        CSTSnackbarSingleton.open(error);
    }
});
//# sourceMappingURL=api.js.map